<template lang="pug">
.TheToasterItem.toaster-item(
  @click="onClick"
  :class="`toaster-item--${type}`"
  @mouseenter="onMouseEnter"
  @mouseleave="onMouseLeave"
  ref="container"
)
  button.toaster-item__close-button(type="button" role="button")
    SolidTimesIcon.svg-icon.times-icon
  .toaster-item__text
    SolidCheckCircleIcon(v-if="isSuccessType").svg-icon.check-circle-icon
    SolidExclamationCircleIcon(v-if="isErrorType").svg-icon.exclamation-circle-icon
    .at-logo(v-if="isInfoType")
      BaseImage( :src="require('images/logo-small.svg')" alt="AT-logo" force)
    span(
      v-html="$_text",
      v-improve-links,
    )
  .toaster-item__more-text.small-text(
    v-if="$_moreText",
    v-html="$_moreText",
    v-improve-links,
  )
</template>

<script>
import SolidTimesIcon from 'images/svg-icons/solid-times.svg';
import SolidCheckCircleIcon from 'images/svg-icons/solid-check-circle.svg';
import SolidExclamationCircleIcon from 'images/svg-icons/solid-exclamation-circle.svg';

export default {
  name: 'TheToasterItem',
  components: {
    SolidTimesIcon,
    SolidCheckCircleIcon,
    SolidExclamationCircleIcon,
  },
  props: {
    text: [String, Array],
    type: {
      validator: value => ['success', 'error', 'info'].includes(value),
      default: 'success',
    },
    timeout: {
      default: 6000,
      validator: val => Number(val) >= 0,
    },
    onMount: Function,
    onUserClose: Function,
  },
  computed: {
    isInfoType() {
      return this.type === 'info';
    },
    isSuccessType() {
      return this.type === 'success';
    },
    isErrorType() {
      return this.type === 'error';
    },
    $_text() {
      if (Array.isArray(this.text)) {
        if (this.isInfoType) return this.text[0];
        return this.text.join(' ');
      }
      return this.text;
    },
    $_moreText() {
      if (this.isInfoType && Array.isArray(this.text)) {
        return this.text[1];
      }
      return '';
    },
  },
  destroyed() {
    this.stopTimeout();
  },
  mounted() {
    if (this.timeout) this.setHideTimeout();
    if (this.onMount) this.onMount(this.$refs.container);
  },
  methods: {
    onClick() {
      if (typeof this.onUserClose === 'function') this.onUserClose();
      this.hide();
    },
    hide() {
      this.stopTimeout();
      this.$emit('hide');
    },
    stopTimeout() {
      clearTimeout(this.hideTimeoutId);
    },
    setHideTimeout() {
      this.startTime = Date.now();
      const timeout = this.timeout - this.passedTime;
      this.hideTimeoutId = setTimeout(this.hide, timeout);
    },
    onMouseEnter() {
      if (!this.timeout) return;
      this.stopTimeout();
      this.passedTime += Date.now() - this.startTime;
    },
    onMouseLeave() {
      if (!this.timeout) return;
      this.setHideTimeout();
    },
  },
  staticData: {
    passedTime: 0,
  },
};
</script>

<style lang="sass" scoped>
  @import '~Styles/_variables'
  .toaster-item
    margin-bottom: 15px
    position: relative
    overflow: hidden
    z-index: 2
    pointer-events: auto
    width: 360px
    padding: 17px 35px 17px 20px
    background-color: white
    border-radius: 2px
    box-shadow: 0 5px 15px 0 rgba(0,0,0,0.15)
    @media screen and (max-width: 576px)
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15)
    @media screen and (max-width: 374px)
      width: 300px
    &--error
      background-color: $support_red
      ::v-deep a
        +mt(.3s)
        display: inline
        color: #fff!important
        border-bottom: solid 1px $white
        &:hover
          +mt(.3s)
          border-bottom: solid 1px transparent
    &--success
      background-color: $secondary
      ::v-deep a
        +mt(.3s)
        display: inline
        color: #fff!important
        border-bottom: solid 1px transparent
        &:hover
          +mt(.3s)
          border-bottom: solid 1px $white
    &--info
      border-radius: 2px
      padding: 0
      position: relative
      padding-top: 6px
      &:before
        content: ''
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 6px
        background-color: $secondary
      .toaster-item__text
        color: $primary
        padding: 15px 35px 17px 20px
        border-left: 1px solid $support_lightgray
        border-right: 1px solid $support_lightgray
        border-bottom: 1px solid $support_lightgray
        .at-logo
          width: 26px
          height: 26px
          border: 1px solid $support_lightgray
          display: flex
          align-items: center
          justify-content: center
          flex-shrink: 0
          border-radius: 100%
          margin-right: 10px
          img
            width: 100%
            height: 11px
      ::v-deep a,
      ::v-deep a.link-1
        position: relative
        display: inline
        z-index: 1
        +mt(.3s)
        color: $primary !important
        line-height: 20px
        font-family: $font-semibold
        border-bottom: solid 2px $support_yellow
        &:hover
          +mt(.3s)
          border-bottom: solid 2px transparent
          color: $primary !important
      .toaster-item__more-text
        padding: 17px 20px
        background-color: #F8F8F8
        border: 1px solid $support_lightgray
        border-top: none
        ::v-deep a
          font-size: 12px
          line-height: 19px
        ::v-deep p
          font-size: 12px
          line-height: 19px
          +font(500)
          margin-bottom: 0
      .toaster-item__close-button
        svg
          fill: $text_gray
    &__text
      color: $white
      font-size: 17px
      line-height: 26px
      font-family: $font-regular
      display: flex
      flex-direction: row
      align-items: flex-start
      svg
        fill: $white
        margin-right: 10px
        margin-top: 5px
        flex-shrink: 0
    &__close-button
      display: flex
      outline: none
      cursor: pointer
      -webkit-appearance: none
      position: absolute
      right: 15px
      top: 15px
      font-size: 12px
      color: $white
      .svg-icon
        fill: $white
        height: sizeInRem(12)
        width: sizeInRem(12)
</style>
